import styled from "styled-components";

export const LoginWrapper = styled.div`
  background-color: #f4f4f4;
  margin-bottom: 15rem;
  padding: 5rem 2.5rem;
  box-shadow: 0 4px 4px 0 #00000040;
  width: 100%;
`;
